export default __webpack_public_path__ + "a9b22607dc5bbf32300c59a23a4c2aee.woff";